// removed by extract-text-webpack-plugin
module.exports = {"loadingContainer":"_1ff5akn0yza6Q6ac-r-m2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading.less
// module id = 1597
// module chunks = 0